import { useContext } from 'react'

import { ExhibitorContext } from './ExhibitorProvider'

export function useExhibitor() {
  return useContext(ExhibitorContext)
}
